// Real-time price updates on the main auction listing page (issue #500).
// Subscribes to AuctionListingChannel and updates .item-price when a bid changes.
import consumer from "./consumer"

function subscribeToAuctionListing() {
  return consumer.subscriptions.create("AuctionListingChannel", {
    received(data) {
      if (data.auction_id == null || data.highest_ad_bid == null) return

      const auctionId = String(data.auction_id)
      const card = document.querySelector(
        `#pills-online-auction [data-auction-id="${auctionId}"]`
      )
      if (!card) return

      const priceEl = card.querySelector(".item-price")
      if (!priceEl) return

      priceEl.textContent = `${data.highest_ad_bid} €`
    }
  })
}

function initAuctionListingRealtime() {
  if (!document.getElementById("pills-online-auction")) return
  if (window._auctionListingSubscription) return
  window._auctionListingSubscription = subscribeToAuctionListing()
}

document.addEventListener("DOMContentLoaded", initAuctionListingRealtime)
if (typeof Turbolinks !== "undefined" && Turbolinks.Events) {
  document.addEventListener("turbolinks:load", initAuctionListingRealtime)
}

export { subscribeToAuctionListing, initAuctionListingRealtime }
